import { renderRoutes } from 'react-router-config';
import { getRoutes, RFC } from 'configs/navigation';

const Meetings: RFC = ({ route }) => {
  return renderRoutes(getRoutes(route));
};

export default Meetings;
